import styled from "styled-components";

export const FilterWrapper = styled.div`
	display: flex;
	gap: 10px;
	margin-bottom: 15px;
	overflow-y: hidden;
	overflow-x: auto;
	align-items: center;

	@media (min-width: 1024px) {
		overflow: unset;
	}

	@media (min-width: 1600px) {
		margin-bottom: 20px;
		padding: 0 50px;
	}
`;

export const FilterSearchWrapper = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: space-between;

	#casino-filter-desktop-search {
		margin-bottom: 15px;
		padding-right: 20px;
	}
`;
